module.exports = __webpack_public_path__ + "img/vegetable-chard-190x100.7d30e733.jpg";